<template>
  <transition name="fade-slide">
    <div v-if="isVisible" class="floating-qr-card-container">
      <!-- Gradient Tab sitting on top of the card using global typography classes -->
      <div class="banner-tab font-inter fs-16 fw-500 color-white">Download the App!</div>

      <!-- Main Card Body -->
      <div class="card-body-content">
        <!-- Left Section (QR Code) -->
        <div class="qr-section">
          <img
            class="qr-image"
            src="@/assets/imgs/newhomepage/hire3x_andriod_qr.png"
            alt="Scan QR code"
          />
          <div class="qr-text font-inter fs-15 fw-700">Scan the QR</div>
        </div>

        <!-- Vertical Divider -->
        <div class="vertical-divider"></div>

        <!-- Right Section (Ratings and Store Badge) -->
        <div class="info-section">
          <!-- Close button using arrow-blue-.svg -->
          <button class="close-card-btn" @click="closeCard" aria-label="Close download card">
            <img
              class="close-icon-img"
              src="@/assets/imgs/newhomepage/arrow-blue-.svg"
              alt="Close"
            />
          </button>

          <!-- Ratings Row -->
          <div class="rating-row">
            <span class="rating-num font-inter fs-20 fw-600">4.6</span>
            <img class="rating-star" src="@/assets/imgs/newhomepage/star-single.svg" alt="Rating Star" />
          </div>

          <!-- Reviews count -->
          <div class="reviews-lbl font-inter fs-20 fw-600">1k+ Reviews</div>

          <!-- Play Store Badge Link -->
          <a
            href="https://play.google.com/store/apps/details?id=com.hire3x.candidate"
            target="_blank"
            rel="noopener noreferrer"
            class="play-store-btn"
          >
            <img
              class="play-store-img"
              src="@/assets/imgs/newhomepage/google-playstore.svg"
              alt="Get it on Google Play"
            />
          </a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "AppDownloadQR",
  data() {
    return {
      isVisible: false,
    };
  },
  mounted() {
    // Show the card after a short, premium delay unless it was closed in the current session
    if (!sessionStorage.getItem("hire3x_app_qr_dismissed")) {
      setTimeout(() => {
        this.isVisible = true;
      }, 1200);
    }
  },
  methods: {
    closeCard() {
      this.isVisible = false;
      sessionStorage.setItem("hire3x_app_qr_dismissed", "true");
    },
  },
};
</script>

<style scoped>
.floating-qr-card-container {
  position: fixed;
  bottom: 7px;
  right: 24px;
  width: 431px;
  height: 197px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  background: transparent;
  pointer-events: none; /* Let clicks pass through empty wrapper areas if any */
}

/* Gradient Tab sitting on top of the card */
.banner-tab {
  width: 215px;
  height: 38px;
  background: linear-gradient(90deg, #4A89FF 0%, #AB44FF 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  pointer-events: auto; /* Re-enable pointer events for banner tab */
  box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.03);
}

/* Main Card Body */
.card-body-content {
  flex-grow: 1;
  background: #ffffff;
  border-radius: 20px;
  border-top-left-radius: 0; /* Keep flat where tab meets the card body */
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(74, 126, 255, 0.08);
  display: flex;
  flex-direction: row;
  align-items: stretch;
  overflow: hidden;
  pointer-events: auto; /* Re-enable pointer events for card content */
  transition: box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* Subtle micro-animation on card body hover */
.floating-qr-card-container:hover .card-body-content {
  box-shadow: 0px 12px 40px rgba(0, 0, 0, 0.16);
}

/* Left Section: QR Code */
.qr-section {
  width: 185px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  padding-top:5px;
}

.qr-image {
  width: 90px;
  height: 90px;
  object-fit: contain;
}

.qr-text {
  color: #4a5568;
  margin-top: 8px;
  text-align: center;
}

/* Vertical Divider */
.vertical-divider {
  width: 1px;
  background-color: #C4DCF6;
  margin: 0;
}

/* Right Section: Ratings and store link */
.info-section {
  flex-grow: 1;
  padding: 25px 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
}

.top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.close-card-btn {
  position: absolute;
  top: 16px;
  right: 20px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
}

.close-card-btn:hover .close-icon-img {
  transform: scale(1.15) rotate(90deg);
  opacity: 0.85;
}

.close-icon-img {
  display: block;
  position: relative;
  top: -7px;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.rating-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rating-num {
  color: #2B2B2B;
  line-height: 1;
}

.rating-star {
  width: 24px;
  height: 24px;
  object-fit: contain;
  display: block;
}

.reviews-lbl {
  color: #515151;
  margin-top: 4px;
}

.play-store-btn {
  margin-top: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #100F0D;
  height: 52px;
  padding: 6px 12px;
  border-radius: 8px;
  align-self: flex-start;
  transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-sizing: border-box;
}

.play-store-btn:hover {
  transform: translateY(-3px) scale(1.02);
}

.play-store-img {
  height: 100%;
  object-fit: contain;
  display: block;
}

/* Entering and leaving transitions */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.fade-slide-enter {
  opacity: 0;
  transform: translateY(30px) scale(0.95);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(30px) scale(0.95);
}

/* Hide on mobile/tablet viewports */
@media (max-width: 1024px) {
  .floating-qr-card-container {
    display: none;
  }
}
</style>
